﻿import React from 'react';

import { GMetrixProgressBar } from 'components/GMetrixProgressBar/GMetrixProgressBar';
import { Col, Container } from 'react-bootstrap';
import { ReportComponent } from 'apis/ReportApi';
import { FormattedMessage } from 'react-intl';

import 'pages/reports/components/ChartProgressBar/styles/chart-progress-bar.scss';

interface ChartProgressBarProps {
	component: ReportComponent;
	generateFakeProgressBars: (countOfProgressBars: number) => JSX.Element[];
	index: number;
	isSubReport?: boolean;
	loading: boolean;
}

export function ChartProgressBar({
    component,
    generateFakeProgressBars,
    index,
    isSubReport = false,
    loading
}: ChartProgressBarProps) {

    return (
        <Col
            className="component-wrapper__col flex-column"
            key={`${component.ComponentId}-${index}`}
            lg={isSubReport ? 12 : component.WidthLg}
            md={isSubReport ? 12 : component.WidthMd}
            sm={isSubReport ? 12 : component.WidthSm}
            xl={isSubReport ? 12 : component.WidthXl}
            xxl={component.WidthXl}
        >
            {!loading ? (
                <div className="chart-progress-bar">
                    <h6 className="text-center chart-progress-bar__title">
                        {component.Title}
                    </h6>
                    {component.Results?.SeriesList.length === 0 && (
                    <div className="text-center">
                        <FormattedMessage defaultMessage="No Results Found" id="no_results_found.f1d71249" />
                    </div>
                    )}

                    {component.Results &&
						component.Results.SeriesList.map(dataList => {

						    let percentageNum = 0;
						    let convertToPercentage = false;
						    dataList.Data.map((dataItem, i) => {

						        if (Number(dataItem.Share) > 100) {

						            convertToPercentage = true;

						        }
						        percentageNum += Number(dataItem.Share);

						    });
						    return dataList.Data.map((dataItem, i) => {

						        if (convertToPercentage) {

						            dataItem.Share = String(
						                ((Number(dataItem.Share) / percentageNum) * 100).toFixed(2)
						            );

						        }
						        return <GMetrixProgressBar dataItem={dataItem} key={i} />;

						    });

						})}
                </div>
            ) : (
                <Container>
                    {generateFakeProgressBars(component.ResultsCount)}
                </Container>
            )}
        </Col>
    );

}
